const productsAdditional = $("body.type-detail .products-additional");
const mobileSlider = window.matchMedia("(max-width: 991px)");

function setProductsAdditionalSlider() {
  if (mobileSlider.matches && !productsAdditional.hasClass("slick-initialized")) {
    productsAdditional.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: false,
      autoplay: false,
      autoplaySpeed: 5000,
      dots: false,
      arrows: true,
      infinite: false,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 549,
          settings: { slidesToShow: 2 },
        },
      ],
    });
  } else if (!mobileSlider.matches && productsAdditional.hasClass("slick-initialized")) {
    productsAdditional.slick("unslick");
  }
}

setProductsAdditionalSlider();
mobileSlider.addEventListener("change", setProductsAdditionalSlider);
